<div class="atn-ds-table-embedded">
  @if (store.hasSearchSg()) {
    <embedded-search />
  }
  <table-data />
  @if (store.showPaginationSg()) {
    <embedded-pagination />
  }
</div>
